import { FC } from 'react';
import { RadioGroup, RadioGroupItem } from '@features/ui';
import { TOption } from '@src/types';

interface FilterDataProps {
  title: string;
  radioSelected: string;
  setRadioSelected: (radioSelected: string) => void;
  options: TOption[];
}
export const FilterData: FC<FilterDataProps> = ({
  title,
  radioSelected,
  setRadioSelected,
  options,
}) => {
  return (
    <div
      className={
        'flex items-center gap-x-3 text-xs lg:absolute lg:right-0 lg:z-1 lg:top-0 lg:mb-0 mb-4.5'
      }
    >
      <p className={'text-lg'}>{title}</p>
      <RadioGroup
        className={'flex item-center gap-x-2'}
        value={radioSelected}
        onValueChange={(value) => setRadioSelected(value)}
      >
        {options.map((item) => {
          return (
            <div key={item.value} className={'flex items-center gap-x-2'}>
              <RadioGroupItem value={item.value} />
              <p>{item.label}</p>
            </div>
          );
        })}
      </RadioGroup>
    </div>
  );
};
